
<div style="padding: 20px;">
    <p>Assign Collector</p>
    <mat-slide-toggle [(ngModel)]="isLock">Lock</mat-slide-toggle>
    <div style="display: flex; flex-direction: row;">
        <mat-form-field appearance="outline" class="custom-mat-field">
            <mat-label>Collector</mat-label>
            <mat-select [(ngModel)]="selectedEmpID" (selectionChange)="selectedCollector($event)" [formControl]="collectorName" required>
                <mat-option *ngFor="let item of collectorNames" [value]="item.employeeID">
                    {{item.full_name}}
                </mat-option>
            </mat-select>
        </mat-form-field><br>
        <button mat-flat-button color="primary" (click)="onAssign()" [disabled]="collectorName.invalid">Assign</button>
        <button mat-stroked-button (click)="onClose()">Close</button>
    </div>
</div>
